<template lang="pug">
    section#ingressar
        div.wrapper
            h2
                |Como Ingressar:
                br
                |NÃO PRECISA DE VESTIBULAR!
            span
                |Você ingressa a partir da análise dos seguintes documentos:
            ul
                li
                    |Histórico Escolar parcial do curso de origem;

                li
                    |Ementário das disciplinas do curso de origem;

                li
                    |Descrição de Regimento sobre o processo de avaliação do curso de origem;

                li
                    |Ter cursado pelo menos 1 semestre na IES ou curso de origem.*
            p
                |A política de transferências externas da UniFAEL não permite a admissão de alunos que estejam cursando o último período.
                br
                |*Alunos que não tenham cursado um semestre completo - concluído - pelo menos, ingressam como calouro.*
            a(href="#").button.disabled INSCRIÇÕES AINDA NÃO LIBERADAS
</template>

<script>
export default {
    name: "section-ingressar"
}
</script>

<style lang="stylus" scoped src="./Ingressar.styl"></style>
